import HeadingComponent from "./HeadingComponent";
import mail from "../../../public/static/images/svg/SVGMailFill.svg";
import phone from "../../../public/static/images/svg/SVGPhoneFill.svg";
import whatsapp from "../../../public/static/images/svg/SVGWhatsappFill.svg";
import fb from "../../../public/static/images/svg/SVGFacebookFill.svg";
import addressIcon from "../../../public/static/images/svg/Bitmap-2SVG.svg";

type ContactInformationProps = {
  title?: string;
  email?: string;
  optEmail?: string;
  phonenumber?: string;
  timeframe?: string;
  extraText1?: string;
  extraText2?: string;
  mailhref?: string;
  telhref?: string;
  fbIcon?: boolean;
  fbhref?: string;
  address?: string;
  emailhci?: string;
  callhci?: string;
  marginTop?: string;
  whatsappHref?: string;
  whatsappNumber?: string;
  customWidth?: boolean;
};

export const ContactInformation = ({
  title,
  email,
  optEmail,
  phonenumber,
  timeframe,
  extraText1,
  extraText2,
  mailhref,
  telhref,
  fbIcon = false,
  fbhref,
  address,
  emailhci = "Kirimkan email ke",
  callhci,
  marginTop,
  whatsappHref,
  whatsappNumber,
  customWidth
}: ContactInformationProps) => {
  return (
    <div className="contact-info-wrapper">
      <HeadingComponent
        margin="16px"
        fontWeight="bold"
        headingText={title}
      ></HeadingComponent>
      <div className="contact-info-container">
        {(mailhref || email) && (
          <a href={mailhref} target="_blank" data-cy="ci-send-email-anchor">
            <div className="icon-text">
              <img src={mail}></img>
              <div>
                <p>{emailhci}</p>
                <p>
                  {extraText1 && extraText1 + ` : `}
                  <span style={{ color: "var(--color-red)" }}>{email}</span>
                </p>
                {optEmail && (
                  <>
                    <p>atau</p>
                    <p>
                      {extraText2 && extraText2 + ` : `}
                      <span style={{ color: "var(--color-red)" }}>
                        {optEmail}
                      </span>
                    </p>
                    <br />
                  </>
                )}
              </div>
            </div>
          </a>
        )}

        {(callhci || phonenumber) && (
          <a href={telhref} data-cy="ci-call-anchor">
            <div className="icon-text">
              <img src={phone}></img>
              <div>
                <p>{callhci}</p>
                <p>
                  {extraText1 && extraText1 + ` : `}
                  <span style={{ color: "var(--color-red)" }}>
                    {phonenumber}
                  </span>
                </p>
                {timeframe && (
                  <>
                    <p>{timeframe}</p>
                    <i>(kecuali hari libur nasional)</i>
                  </>
                )}
              </div>
            </div>
          </a>
        )}

        {(fbIcon || fbhref) && (
          <a href={fbhref} target="_blank">
            <div className="icon-text">
              <img src={fb}></img>
              <div>
                <p>
                  <i>Chat</i> dengan kami di Facebook
                </p>
              </div>
            </div>
          </a>
        )}

        {(whatsappHref || whatsappNumber) && (
          <a href={whatsappHref} target="_blank" data-cy="ci-wa-anchor">
            <div className="icon-text">
              <img src={whatsapp}></img>
              <div>
                <p>Chat WhatsApp resmi kami di</p>
                <p style={{ color: "var(--color-red)" }}>{whatsappNumber}</p>
                <p>Setiap hari, 07.00 – 20.00 WIB</p>
              </div>
            </div>
          </a>
        )}

        {address && (
          <div className="icon-text">
            <img src={addressIcon}></img>
            <div>
              <p>Kirimkan surat ke</p>
              <p style={{ fontFamily: "Roboto; font-weight: bold" }}>
                PT Home Credit Indonesia
              </p>
              <p>
                Customer Care Center, Plaza Oleos Lt. 8 JI. TB Simatupang No.
                53A, Jakarta Selatan 12520, Indonesia
              </p>
            </div>
          </div>
        )}
      </div>
      <style jsx>{`
        .contact-info-wrapper {
          margin-top: 32px;
          margin-bottom: 64px;
        }
        .contact-info-container {
          display: flex;
          justify-content: center;
        }
        .address {
          max-width: 299px;
        }
        .icon-text {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: 0 50px;
        }
        .icon-text img {
          height: 80px;
          margin: 0 24px 24px 24px;
        }
        .icon-text p {
          margin: 0px;
        }
        .icon-text div {
          text-align: center;
        }
        @media only screen and (min-width: 1230px){
          .icon-text{
            width: ${customWidth ? '350px' : ''};
          }
        }
        @media only screen and (max-width: 600px) {
          .contact-info-wrapper {
            margin-bottom: 24px;
            margin-top: ${marginTop};
          }
          .contact-info-container {
            flex-direction: column;
            align-items: center;
          }
          .icon-text {
            flex-direction: row;
            margin: 10px 0px;
            width: ${extraText1 || extraText2 ? "336px" : "270px"};
          }
          .icon-text img {
            width: 32px;
            height: auto;
            margin: 16px;
          }
          .icon-text div {
            text-align: left;
            font-size: 12px;
          }
        }
        @media only screen and (max-width: 320px) {
          .icon-text {
            width: ${extraText1 || extraText2 ? "318px" : "270px"};
          }
          .icon-text div {
            font-size: ${extraText1 || extraText2 ? "10px" : "12px"};
          }
        }
      `}</style>
    </div>
  );
};

export default ContactInformation;
